<template>
    <Autosuggest
        :value="value"
        :options="addresses"
        :label="config.PROFILE_ADDRESS_STREET"
        :loading="loading"
        :spinnerColor="config.COLOR_PRIMARY"
        @input="onInput"
        @select="onSelect"
    >
        <template v-slot="{ option }">
            {{ option.formatted }}
        </template>
    </Autosuggest>
</template>
<script>
import debounce from 'lodash.debounce';

import { Autosuggest } from '../lib';
import { SolutionConsumer, UserConsumer } from '../../mixins';

export default {
    name: 'AddressAutocomplete',
    components: { Autosuggest },
    mixins: [SolutionConsumer, UserConsumer],
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            loading: false,
            addresses: [],
            lastQuery: null,
        };
    },
    methods: {
        onInput (value) {
            this.$emit('input', value);
            this.onSearch(value);
        },
        onSelect (address) {
            this.$emit('select', address);
        },
        // eslint-disable-next-line func-names
        onSearch: debounce(function (query) {
            if (query) {
                this.loading = true;
                this.lastQuery = query;
                this.searchAddress(query)
                    .catch((err) => {
                        console.error(err);
                        return [];
                    })
                    .then((addresses) => {
                        if (this.lastQuery === query) {
                            this.addresses = addresses
                                .map((address) => ({ ...address, name: address.street }))
                                .sort((a, b) => a.formatted.localeCompare(b.formatted));
                            this.loading = false;
                        }
                    });
            }
        }, 1000),
    },
};
</script>
